export default __webpack_public_path__ + "c45652209677eecf100f742329138af9.png";